<template>
  <card class="card-stats">
    <div class="row">
      <div class="col-5" v-if="$slots.header">
        <div class="icon-big text-center">
          <slot name="header"></slot>
        </div>
      </div>
      <div class="col-7">
        <div class="numbers">
          <slot name="content">
            <p v-if="subtitle" class="card-category mb-1">{{subtitle}}</p>
            <div class="csstable">
              <div class="cssrow">
                <h3 class="card-title csscell ">{{value}}</h3>
                <span v-if="received " class="percentage csscell">&nbsp;({{Math.round(100*value/received)}}%)</span>
              </div>
            </div>
            <i v-if="false && previousValue && !(previousValue=='$0')" class="previous-value ml-auto" :class="previousReceived?'':'mr-1'">
              {{previousValue}} <span class="" v-if="previousReceived">({{Math.round(100*previousValue/previousReceived)}}%)</span>
            </i>
          </slot>
        </div>
      </div>
    </div>
    <div class="stats" slot="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </card>
</template>
<script>
  import Card from './Card.vue'
  export default {
    name: 'mini-card',
    components: {
      Card
    },
    props: {
      subtitle:         { type: String, required: true },
      value:                          { required: true },
      previousValue:                  { required: false },
      received:         { type: Number, required: false },
      previousReceived: { type: Number, required: false }
    },
    mounted() {}
  }

</script>
<style scoped>
.col-7 {
  padding-left: 0
}
h3 {
  line-height: 27px;
  width: 100%;
}
.csstable {
  display: table;
  width: 100%;
}
.csscell {
  display: table-cell;
  vertical-align: bottom;
  text-align: right;
}
.cssrow {
  display: table-row;
}
.percentage {
  font-size: 14px;
}
.previous-value {
  color: rgb(200, 200, 200);
  /* color: rgb(190, 190, 190); */
  font-size: 14px;
}

</style>
